import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from '../../../private/shared/modules/shared.module';
import { ReceivedLifePage } from './received-life.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    TranslateModule,
  ],
  declarations: [
    ReceivedLifePage
  ]
})
export class ReceivedLifePageModule {}
